import React from 'react';
import {
  LocalizationContextProvider,
  MbmProvider,
} from '@amzn/react-arb-tools';

import {
  createAsyncMessageBundleManager,
  LocalizationContextBuilder,
} from '@amzn/arb-tools';
import {
  getLocalStorageItem,
  LocalStorageKeys,
} from 'src/utilities/LocalStorage';
import arbManifest from '../../build/i18n/arbManifest';
import { DEFAULT_LOCALE } from '../constants/LocalizationConstants';

const localizationContextProvider = () => {
  const language =
    getLocalStorageItem(LocalStorageKeys.CPR_LANGUAGE) || DEFAULT_LOCALE;
  const lcBuilder = new LocalizationContextBuilder()
    .withLocale(language)
    .withDefaultLocale(DEFAULT_LOCALE)
    .build();
  return lcBuilder;
};

const mbm = createAsyncMessageBundleManager({
  arbManifest,
  localizationContextProvider,
  resolveBundleUrl: (url?: string) =>
    url
      ? `https://d3fz4qwh4u8rcv.cloudfront.net/i18n/${url}`
      : undefined,
});

interface Props {
  children?: React.ReactNode;
}

/**
 * Uses the mbm that's created in src/i18n and makes it available via MbmProvider
 * downstream. Eases the migration to ARB JS by providing a DefaultBundleProvider
 * that downstream components can rely on.
 * @param children
 * @constructor
 */
const ArbI18nextWrapper: React.FC<Props> = ({ children }: Props) => {
  return (
    <LocalizationContextProvider
      localizationContext={localizationContextProvider()}
    >
      <MbmProvider mbm={mbm}>{children}</MbmProvider>
    </LocalizationContextProvider>
  );
};

export default ArbI18nextWrapper;
